<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
      <nav
        (click)="handleBackNavigation()"
        class="navbar sticky-top main-nav px-3"
      >
        <span
          class="back-button f-18 border-0 primary-font-bold mb-4"
          aria-label="Back navigation"
        >
          <img src="/assets/icons/back-btn.svg" alt="back" class="mr-2" />
          Checkout
        </span>
      </nav>

      <div class="p-3 my-3" *ngIf="allOrders?.length === 0">
        <article class="card border-0">
          <div class="text-center">
            <p class="primary-font-normal fw-600 mb-0">
              There are no open orders at the moment.
            </p>
          </div>
        </article>
      </div>

      <div *ngIf="allOrders?.length > 0" id="pdf-content" class="page-content px-3 py-4">
        <mat-accordion>
          <mat-expansion-panel class="mb-2" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <p class="primary-font-medium mb-0">All Orders</p>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let cart of allOrders; index as i">
              <app-order-items
                [isSuccessPage]="true"
                [dishes]="cart"
                [inExpansionPanel]="true"
                (refreshCart)="handleCartRefresh($event)"
              ></app-order-items>

              <p
                *ngIf="getOrderStatus(cart) === 'NEW' || getOrderStatus(cart) === 'UNCONFIRMED'"
                (click)="confirmCancelOrder(cart, i + 1)"
                class="f-14 fw-600 text-center lh-20 text-error-500 primary-font-normal"
                style="cursor: pointer"
              >
                Cancel order {{ i + 1 }}
              </p>

              <div *ngIf="i !== allOrders.length - 1" class="mb-3">
                <img src="/assets/images/divider.svg" alt="line" class="w-100" />
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- <div class="mb-4">
          <img src="/assets/images/divider.svg" alt="line" class="w-100" />
        </div> -->

        <div *ngIf="allOrders?.length > 0" class="card border-radius-3 mt-3">
          <div
            class="d-flex flex-row justify-content-between align-items-center p-3"
          >
            <p class="f-14 primary-font-normal text-gray-600 mb-0">Subtotal</p>

            <p class="f-14 primary-font-normal text-gray-800 mb-0">
              {{ subTotal | currency : '₦' }}
            </p>
          </div>

        

          <!-- <div
            class="d-flex mb-0 flex-row justify-content-between align-items-center px-3"
          >
            <p class="f-14 primary-font-normal text-gray-600 mb-0">Discounts</p>

            <p class="f-14 primary-font-normal text-gray-800 mb-0">
              {{ discounts | currency : '₦' }}
            </p>
          </div> -->

          <ng-container *ngFor="let charge of orderCharges">
            <img src="/assets/images/divider.svg" alt="line" class="w-100 mb-2" />
            <div class="d-flex mb-0 flex-row justify-content-between align-items-center px-3">
              <p class="f-14 primary-font-normal text-gray-600 mb-0">
                {{ charge.name }}
              </p>
              <p class="f-14 primary-font-normal text-gray-800 mb-0">
                {{ charge.amount | currency : '₦' }}
              </p>
            </div>
          </ng-container>

          <img src="/assets/images/divider.svg" alt="line" class="w-100" />

          <div
            class="d-flex mb-2 flex-row justify-content-between align-items-center p-3"
          >
            <p class="f-14 primary-font-normal text-gray-600 mb-0">Total</p>

            <p class="f-14 primary-font-normal text-gray-800 mb-0">
              {{ grandTotal | currency : '₦' }}
            </p>
          </div>

          <div class="p-3" id="pdf-actions">
            <ng-container *ngIf="!isGeneratingPdf; else generating">
              <button
                class="btn btn-dark btn-block f-14 primary-font-normal"
                (click)="showPaymentBottomSheet()"
              >
                Pay {{ grandTotal | currency : '₦' }}
              </button>

              <div class="pb-4 mt-3">
                <button
                  (click)="downloadPDF()"
                  class="btn btn-block btn-download-pdf f-14 fw-600 primary-font-normal"
                >
                  <img src="/assets/icons/download.svg" alt="" class="mr-2" />
                  Download bill
                </button>
              </div>
            </ng-container>
            
            <ng-template #generating>
              <div class="d-flex align-items-center justify-content-center py-3">
                <i class="fa fa-spinner fa-spin mr-2"></i>
                <span class="f-14">Generating Bill...</span>
              </div>
            </ng-template>
            
            <!--
            <div class="text-center my-3">
              <p
                (click)="handleOrderCancellation()"
                class="f-14 fw-600 lh-20 text-error-500 primary-font-normal mb-0"
              >
                Cancel order
              </p>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Off-screen receipt for PDF generation -->
<div id="receipt-content" class="receipt">
  <!-- Header -->
  <div class="receipt__header receipt__pdf-slice">
    <img
      *ngIf="restaurantInfo?.logoUrl"
      [src]="restaurantInfo.logoUrl"
      class="receipt__logo"
      alt="logo"
      crossorigin="anonymous"
    />
    <h2 class="receipt__name">{{ restaurantInfo?.name }}</h2>
    <p class="receipt__address">{{ receiptAddress }}</p>
    <p class="receipt__date">{{ receiptDate }}</p>
  </div>

  <!-- Items table -->
  <table class="receipt__table">
    <thead>
      <tr class="receipt__pdf-slice">
        <th>ITEMS</th>
        <th>QTY</th>
        <th>PRICE</th>
        <th>TOTAL</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let meal of receiptItems">
        <tr class="receipt__item-row receipt__pdf-slice">
          <td>{{ meal.name }}</td>
          <td>x{{ meal.quantityOrdered }}</td>
          <td>{{ meal.price | currency : '₦' : 'symbol' : '1.0-0' }}</td>
          <td>{{ meal.price * meal.quantityOrdered | currency : '₦' : 'symbol' : '1.0-0' }}</td>
        </tr>
        <tr *ngFor="let addon of meal.addOns" class="receipt__addon-row receipt__pdf-slice">
          <td>+ {{ addon.name || addon.type }}</td>
          <td>x{{ addon.quantityOrdered || 1 }}</td>
          <td>{{ addon.price | currency : '₦' : 'symbol' : '1.0-0' }}</td>
          <td>{{ addon.price * (addon.quantityOrdered || 1) | currency : '₦' : 'symbol' : '1.0-0' }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <!-- Summary -->
  <div class="receipt__summary">
    <div class="receipt__summary-row receipt__pdf-slice">
      <span>Subtotal</span>
      <span>{{ subTotal | currency : '₦' }}</span>
    </div>
    <div *ngFor="let charge of orderCharges" class="receipt__summary-row receipt__pdf-slice">
      <span>{{ charge.name }} ({{ charge.rate }}%)</span>
      <span>{{ charge.amount | currency : '₦' }}</span>
    </div>
    <div class="receipt__divider receipt__pdf-slice"></div>
    <div class="receipt__summary-row receipt__total-row receipt__pdf-slice">
      <span>Total</span>
      <span>{{ grandTotal | currency : '₦' }}</span>
    </div>
  </div>

  <!-- Footer -->
  <div class="receipt__footer receipt__pdf-slice">
    <span>Powered by SmartMenu</span>
    <img
      src="/assets/icons/logos.svg"
      alt="SmartMenu"
      class="receipt__footer-mark"
    />
  </div>
</div>